export type UserContextTranslation = {
  onboarding: string;
};

export const userContextTranslation: UserContextTranslation = {
  onboarding: 'Trwa synchronizacja danych. Prosimy czekać',
};
